export default function () {
  return [
    // Dashboard
    {
      title: 'Painel de controle',
      name: 'dashboard',
      to: {
        name: 'admin-overview',
      },
      htmlBefore: '<i class="material-icons">dashboard</i>',
    },
    // Generate
    {
      title: 'Gerador de texto',
      name: 'generate',
      to: {
        name: 'admin-generate-new',
      },
      htmlBefore: '<i class="material-icons">engineering</i>',
    },
    // Separate words
    {
      title: 'Separador de palavras',
      name: 'word-separator',
      to: {
        name: 'admin-word-separator-new',
      },
      htmlBefore: '<i class="material-icons">spellcheck</i>',
    },
    // Special Character Remover
    {
      title: 'Removedor de caracteres especiais',
      name: 'special-character-remover',
      to: {
        name: 'admin-special-character-remover-new',
      },
      htmlBefore: '<i class="material-icons">auto_fix_normal</i>',
    },
    // Groups words
    {
      title: 'Agrupador de palavras',
      name: 'word-groups',
      to: {
        name: 'admin-word-groups-new',
      },
      htmlBefore: '<i class="material-icons">bar_chart</i>',
    },
    // Cryptogram Generator
    {
      title: 'Criptogramas',
      name: 'cryptogram-generator',
      htmlBefore: '<i class="material-icons">lock</i>',
      to: {
        name: 'admin-cryptogram-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-cryptogram-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-cryptogram-new',
          },
        },
      ],
    },
    // Words
    {
      title: 'Banco de palavras',
      name: 'words',
      to: {
        name: 'admin-word-new',
      },
      htmlBefore: '<i class="material-icons">storage</i>',
      items: [
        {
          isAdmin: true,
          title: 'Lista de palavras',
          to: {
            name: 'admin-word-list',
            params: {
              page: 1,
            },
          },
        },
        {
          isAdmin: true,
          title: 'Importar palavras',
          to: {
            name: 'admin-word-list-import',
            params: {
              page: 1,
            },
          },
        },
        {
          isAdmin: false,
          title: 'Adicionar palavras',
          to: {
            name: 'admin-word-new',
          },
        },
      ],
    },
    // Cruzadas
    {
      title: 'Cruzadas',
      name: 'puzzle',
      to: {
        name: 'admin-crossword-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">extension</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-crossword-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-crossword-new',
          },
        },
        {
          title: 'Lista Templates',
          to: {
            name: 'admin-crossword-template-list',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    // Hunting Words
    {
      title: 'Caça Palavras',
      name: 'hunting-words',
      to: {
        name: 'admin-hunting-words-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">font_download</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-hunting-words-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-hunting-words-new',
          },
        },
      ],
    },
    // Shapes Links
    {
      title: 'Shape Links',
      name: 'shape-links',
      to: {
        name: 'admin-shape-links-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">category</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-shape-links-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-shape-links-new',
          },
        },
      ],
    },
    // Loop
    {
      title: 'Loop',
      name: 'puzzle-loop',
      to: {
        name: 'admin-puzzle-loop-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">repeat_on</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-puzzle-loop-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-puzzle-loop-new',
          },
        },
      ],
    },
    // numberSquare
    {
      title: 'Number Square',
      name: 'puzzle-number-square',
      to: {
        name: 'admin-puzzle-number-square-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">calculate</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-puzzle-number-square-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-puzzle-number-square-new',
          },
        },
      ],
    },
    // Fences
    {
      title: 'Fences',
      name: 'puzzle-fences',
      to: {
        name: 'admin-puzzle-fences-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">fullscreen_exit</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-puzzle-fences-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-puzzle-fences-new',
          },
        },
      ],
    },
    // Walls
    {
      title: 'Walls',
      name: 'puzzle-walls',
      to: {
        name: 'admin-puzzle-walls-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">density_small</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-puzzle-walls-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-puzzle-walls-new',
          },
        },
      ],
    },
    // Puzzle term
    {
      title: 'Termo',
      name: 'term',
      to: {
        name: 'admin-puzzle-term-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">view_module</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-puzzle-term-list',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    // User
    {
      title: 'Usuários',
      name: 'users',
      to: {
        name: 'admin-user-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">perm_identity</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-user-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-user-new',
          },
        },
      ],
    },
  ];
}
